<template>
  <div v-if="investment">
    <TheHeader
      with-menu
      back-route="."
    />
    <BaseSection>
      <BaseTitleGroup
        :subtitle="`${$t('My investments')} / ${participation.attributes.name}`"
        :title="$t('Reportings')"
        class="pb-8"
      />
    </BaseSection>
    <BaseSection class="mb-8">
      <BaseSectionHeader class="pt-4 border-t border-strong-shadow-color">
        {{ $t('Quarterly reports') }}
      </BaseSectionHeader>
      <BaseMenuList
        v-if="reportings.length"
        :items="transformDocuments(reportings)"
      />
      <BaseEmptyState
        v-else
        :src="image"
        alt="Reportings empty state"
        class="pt-4"
      >
        <span v-html="$t('Reportings empty state')" />
      </BaseEmptyState>
    </BaseSection>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import loadInvestment from '../mixins/loadInvestment';
import TheHeader from '../components/TheHeader.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseSectionHeader from '../components/BaseSectionHeader.vue';
import BaseMenuList from '../components/BaseMenuList.vue';
import BaseEmptyState from '../components/BaseEmptyState.vue';
import image from '../assets/document.svg';

export default {
  name: 'InvestmentReporting',

  components: {
    TheHeader,
    BaseSection,
    BaseTitleGroup,
    BaseSectionHeader,
    BaseMenuList,
    BaseEmptyState,
  },

  mixins: [loadInvestment],

  data() {
    return {
      image,
    };
  },

  computed: mapGetters('investment', ['reportings']),
};
</script>
